import { useEffect, useState, useContext } from "react";
import DataTable from "react-data-table-component";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  NavLink,
} from "react-router-dom";

import { Chart as ChartJS, ArcElement, Tooltip, Legend } from "chart.js/auto";
import { Doughnut } from "react-chartjs-2";
import Tab from "react-bootstrap/Tab";
import Tabs from "react-bootstrap/Tabs";
import axios from "axios";
import Web3 from "web3";
import { devCondoABI } from "../../utils/constant/abi";
import { fetchCondo } from "../../utils/services/api";
import { TreasuryContext } from "../../context/TreasuryContextProvider";
import "./TreasuryBalance.css";
ChartJS.register(ArcElement, Tooltip, Legend);
export const datum = {
  datasets: [
    {
      data: [20, 22, 13, 2],
      backgroundColor: ["rgb(255, 85, 0)", "", "", ""],
    },
  ],
};
export const datum2 = {
  datasets: [
    {
      data: [10, 22, 13, 2],
      backgroundColor: ["rgb(255, 85, 0)", "", "", ""],
    },
  ],
};
export const data2 = {
  datasets: [
    {
      data: [3, 22, 13, 2],
      backgroundColor: ["rgb(255, 85, 0)", "", "", ""],
    },
  ],
};
export const datum3 = {
  datasets: [
    {
      data: [43, 22, 13, 2],
      backgroundColor: ["rgb(255, 85, 0)", "", "", ""],
    },
  ],
};
const TreasureOverview = () => {
  const { totalTreasury } = useContext(TreasuryContext);
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  const condobasecontractAddress = "0x6404b20b5a8493c426b6efbe52809b206b26d393";
  const treasurycontractAddress = "0x8A7Ebadd4bb0d7015859AFBD26208fc5BA1e15c4";
  const condobaseEtherAddress = "0xC6b79C32c292271a346B9a435F49f6C2B19D1510";
  const condoPolygonTreasury = " 0x4bF52ff02cc24ecD3d0e8E104f178647893Bd310";
  const brickkenContract = "0x0e28bC9B03971E95acF9ae1326E51ecF9C55B498";
  const [tokenData, setTokenData] = useState(null);
  const condoABI = [
    {
      inputs: [
        { internalType: "address", name: "_uniswapV2Router", type: "address" },
        { internalType: "address", name: "_treasuryWallet", type: "address" },
        { internalType: "uint256", name: "_threshold", type: "uint256" },
      ],
      stateMutability: "nonpayable",
      type: "constructor",
    },
    {
      inputs: [
        { internalType: "address", name: "spender", type: "address" },
        { internalType: "uint256", name: "allowance", type: "uint256" },
        { internalType: "uint256", name: "needed", type: "uint256" },
      ],
      name: "ERC20InsufficientAllowance",
      type: "error",
    },
    {
      inputs: [
        { internalType: "address", name: "sender", type: "address" },
        { internalType: "uint256", name: "balance", type: "uint256" },
        { internalType: "uint256", name: "needed", type: "uint256" },
      ],
      name: "ERC20InsufficientBalance",
      type: "error",
    },
    {
      inputs: [{ internalType: "address", name: "approver", type: "address" }],
      name: "ERC20InvalidApprover",
      type: "error",
    },
    {
      inputs: [{ internalType: "address", name: "receiver", type: "address" }],
      name: "ERC20InvalidReceiver",
      type: "error",
    },
    {
      inputs: [{ internalType: "address", name: "sender", type: "address" }],
      name: "ERC20InvalidSender",
      type: "error",
    },
    {
      inputs: [{ internalType: "address", name: "spender", type: "address" }],
      name: "ERC20InvalidSpender",
      type: "error",
    },
    {
      inputs: [{ internalType: "address", name: "owner", type: "address" }],
      name: "OwnableInvalidOwner",
      type: "error",
    },
    {
      inputs: [{ internalType: "address", name: "account", type: "address" }],
      name: "OwnableUnauthorizedAccount",
      type: "error",
    },
    { inputs: [], name: "ReentrancyGuardReentrantCall", type: "error" },
    {
      anonymous: false,
      inputs: [
        {
          indexed: true,
          internalType: "address",
          name: "owner",
          type: "address",
        },
        {
          indexed: true,
          internalType: "address",
          name: "spender",
          type: "address",
        },
        {
          indexed: false,
          internalType: "uint256",
          name: "value",
          type: "uint256",
        },
      ],
      name: "Approval",
      type: "event",
    },
    {
      anonymous: false,
      inputs: [
        {
          indexed: true,
          internalType: "address",
          name: "account",
          type: "address",
        },
        {
          indexed: false,
          internalType: "bool",
          name: "isExcluded",
          type: "bool",
        },
      ],
      name: "ExcludeFromFees",
      type: "event",
    },
    {
      anonymous: false,
      inputs: [
        {
          indexed: true,
          internalType: "address",
          name: "previousOwner",
          type: "address",
        },
        {
          indexed: true,
          internalType: "address",
          name: "newOwner",
          type: "address",
        },
      ],
      name: "OwnershipTransferred",
      type: "event",
    },
    {
      anonymous: false,
      inputs: [
        {
          indexed: true,
          internalType: "address",
          name: "pair",
          type: "address",
        },
        { indexed: true, internalType: "bool", name: "value", type: "bool" },
      ],
      name: "SetAutomatedMarketMakerPair",
      type: "event",
    },
    {
      anonymous: false,
      inputs: [
        {
          indexed: true,
          internalType: "address",
          name: "from",
          type: "address",
        },
        { indexed: true, internalType: "address", name: "to", type: "address" },
        {
          indexed: false,
          internalType: "uint256",
          name: "value",
          type: "uint256",
        },
      ],
      name: "Transfer",
      type: "event",
    },
    {
      inputs: [
        { internalType: "address", name: "owner", type: "address" },
        { internalType: "address", name: "spender", type: "address" },
      ],
      name: "allowance",
      outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
      stateMutability: "view",
      type: "function",
    },
    {
      inputs: [
        { internalType: "address", name: "spender", type: "address" },
        { internalType: "uint256", name: "value", type: "uint256" },
      ],
      name: "approve",
      outputs: [{ internalType: "bool", name: "", type: "bool" }],
      stateMutability: "nonpayable",
      type: "function",
    },
    {
      inputs: [{ internalType: "address", name: "", type: "address" }],
      name: "automatedMarketMakerPairs",
      outputs: [{ internalType: "bool", name: "", type: "bool" }],
      stateMutability: "view",
      type: "function",
    },
    {
      inputs: [{ internalType: "address", name: "account", type: "address" }],
      name: "balanceOf",
      outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
      stateMutability: "view",
      type: "function",
    },
    {
      inputs: [],
      name: "buyFee",
      outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
      stateMutability: "view",
      type: "function",
    },
    {
      inputs: [],
      name: "decimals",
      outputs: [{ internalType: "uint8", name: "", type: "uint8" }],
      stateMutability: "view",
      type: "function",
    },
    {
      inputs: [],
      name: "name",
      outputs: [{ internalType: "string", name: "", type: "string" }],
      stateMutability: "view",
      type: "function",
    },
    {
      inputs: [],
      name: "owner",
      outputs: [{ internalType: "address", name: "", type: "address" }],
      stateMutability: "view",
      type: "function",
    },
    {
      inputs: [],
      name: "renounceOwnership",
      outputs: [],
      stateMutability: "nonpayable",
      type: "function",
    },
    {
      inputs: [],
      name: "sellFee",
      outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
      stateMutability: "view",
      type: "function",
    },
    {
      inputs: [],
      name: "symbol",
      outputs: [{ internalType: "string", name: "", type: "string" }],
      stateMutability: "view",
      type: "function",
    },
    {
      inputs: [],
      name: "totalSupply",
      outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
      stateMutability: "view",
      type: "function",
    },
    {
      inputs: [
        { internalType: "address", name: "to", type: "address" },
        { internalType: "uint256", name: "value", type: "uint256" },
      ],
      name: "transfer",
      outputs: [{ internalType: "bool", name: "", type: "bool" }],
      stateMutability: "nonpayable",
      type: "function",
    },
    {
      inputs: [
        { internalType: "address", name: "from", type: "address" },
        { internalType: "address", name: "to", type: "address" },
        { internalType: "uint256", name: "value", type: "uint256" },
      ],
      name: "transferFrom",
      outputs: [{ internalType: "bool", name: "", type: "bool" }],
      stateMutability: "nonpayable",
      type: "function",
    },
    {
      inputs: [{ internalType: "address", name: "newOwner", type: "address" }],
      name: "transferOwnership",
      outputs: [],
      stateMutability: "nonpayable",
      type: "function",
    },
    {
      inputs: [],
      name: "treasuryWallet",
      outputs: [{ internalType: "address", name: "", type: "address" }],
      stateMutability: "view",
      type: "function",
    },
    {
      inputs: [],
      name: "uniswapV2Pair",
      outputs: [{ internalType: "address", name: "", type: "address" }],
      stateMutability: "view",
      type: "function",
    },
    {
      inputs: [],
      name: "uniswapV2Router",
      outputs: [
        {
          internalType: "contract IUniswapV2Router02",
          name: "",
          type: "address",
        },
      ],
      stateMutability: "view",
      type: "function",
    },
  ];
  const condoAirdropAddress = "0x1aaed91A496d8D875A33820d09b2a68541Fb8B3D";
  const baseWalletAddress = "0x30D19Fb77C3Ee5cFa97f73D72c6A1E509fa06AEf";
  const devWalletAddress = "0xEf3E49a3197417ccDbF5F6A60D89f7Fa4823199d";
  const mapleContract = "0x33349B282065b0284d756F0577FB39c158F935e6";

  const [totalBalance, setTotalBalance] = useState(null);
  const [totalCondo, setTotalCondo] = useState(null);
  const devCondoContract = "0x30D19Fb77C3Ee5cFa97f73D72c6A1E509fa06AEf";
  const [totalDevWallet, setTotalDevWallet] = useState(null);
  const [devWalletBal, setDevWalletBal] = useState(null);
  const [totalDevWalletCondo, setTotalDevWalletCondo] = useState(null);
  useEffect(() => {
    const web3 = new Web3(
      "https://base-mainnet.g.alchemy.com/v2/H1rJyGFx5Lny_Lu9ALavFSjD9fEpReZ4"
    );
    const addressToCheck = "0x6404B20B5a8493c426b6efBE52809B206b26d393";
    web3.eth.getBalance(addressToCheck).then(async (balance) => {
      const condoBalance = web3.utils.fromWei(balance, "ether");
      // const exchangeRateResponse = await axios.get(
      //   "https://api.coingecko.com/api/v3/simple/price?ids=ethereum&vs_currencies=usd"
      // );

      // const ethToUsdRates = exchangeRateResponse.data.ethereum.usd;

      // setTotalBalance(
      //   Number(
      //     parseFloat(condoBalance * ethToUsdRates).toFixed(2)
      //   ).toLocaleString()
      // );
      // console.log("TresuryBalance", condoBalance);
      // console.log("treasuryTotalBalance", treasuryTotalBalance);
    });
    // web3.eth.getBalance(baseWalletAddress).then(async (balance) => {
    //   const condoRealBalance = 5000000000;
    //   const exchangeRateResp = await axios.get(
    //     "https://api.coingecko.com/api/v3/simple/price?ids=condo&vs_currencies=usd"
    //   );
    //   const condoToUsdrates = exchangeRateResp.data.condo.usd;
    //   const totalCondobalance = parseFloat(
    //     condoRealBalance * condoToUsdrates
    //   ).toFixed(2);
    //   setTotalCondo(Number(totalCondobalance).toLocaleString());
    //   console.log("condoBalance", condoRealBalance);
    // });
  }, []);

  useEffect(() => {
    const web3 = new Web3(
      "https://base-mainnet.g.alchemy.com/v2/H1rJyGFx5Lny_Lu9ALavFSjD9fEpReZ4"
    );
    const tokenContract = new web3.eth.Contract(condoABI, baseWalletAddress);
    async function getBalance() {
      try {
        const balance = await tokenContract.methods
          .balanceOf(condoAirdropAddress)
          .call();
        const condoBalance = web3.utils.fromWei(balance, "ether");
        const exchangeRateResponse = await fetchCondo();
        const condoToUsdrates = exchangeRateResponse.current_price;

        setTotalCondo(
          Number(
            parseFloat(condoBalance * condoToUsdrates).toFixed(2)
          ).toLocaleString()
        );
      } catch (error) {
        console.error("Error fetching balance:", error);
      }
    }
    getBalance();
  }, []);

  // devWalletCondoABI
  // useEffect(() => {
  //   const web3 = new Web3(
  //     "https://base-mainnet.g.alchemy.com/v2/H1rJyGFx5Lny_Lu9ALavFSjD9fEpReZ4"
  //   );

  //   //Get balance
  //   const tokenContract = new web3.eth.Contract(devCondoABI, devCondoContract);
  //   async function getBalance() {
  //     try {
  //       const balance = await tokenContract.methods
  //         .balanceOf(devWalletAddress)
  //         .call();

  //       const devWalletBal = web3.utils.fromWei(balance, "ether");
  //       setDevWalletBal(devWalletBal);

  //       const exchangeRateResponse = await fetchCondo();
  //       const devCondoToUsdrates = exchangeRateResponse.current_price;
  //       setTotalDevWalletCondo(
  //         Number(parseFloat(devWalletBal * devCondoToUsdrates).toFixed(2))
  //       );
  //       // console.log("totaldevWalletHomeCondo", totalDevWalletCondo);
  //     } catch (error) {
  //       console.error("Error fetching balance:", error);
  //     }
  //   }
  //   getBalance();
  // }, []);
  // console.log("devWallet", totalDevWallet);
  useEffect(() => {
    const fetchData = async () => {
      const res = await fetchCondo();
      setTokenData(res.platform);
    };
    fetchData();
  }, []);
  const [data, setData] = useState([
    {
      id: 1,
      asset: "USD Coin",
      amount: "35,958,811",
      value: "$35,958,811",
      purchaseValue: "	$35,347,172	",
      allocation: "30.44%",
      change: "	+2.4%",
    },
    {
      id: 2,
      asset: "Tether USD",
      amount: "3,186,072",
      value: "$3,186,072",
      purchaseValue: "	$3,186,072	",
      allocation: "2.70%	",
      change: "+148.0%",
    },
    {
      id: 3,
      asset: "Other Liquid Tokens",
      amount: "-",
      value: "$0",
      purchaseValue: "$0",
      allocation: "0.00%",
      change: "-100.0%",
    },
  ]);
  const [datasec, setDataSec] = useState([
    {
      id: 1,
      asset: "USD Coin",
      amount: "35,958,811",
      value: "$35,958,811",
      purchaseValue: "	$35,347,172	",
      allocation: "30.44%",
      change: "	+2.4%",
    },
    {
      id: 2,
      asset: "Tether USD",
      amount: "3,186,072",
      value: "$3,186,072",
      purchaseValue: "	$3,186,072	",
      allocation: "2.70%	",
      change: "+148.0%",
    },
    {
      id: 3,
      asset: "Other Liquid Tokens",
      amount: "-",
      value: "$0",
      purchaseValue: "$0",
      allocation: "0.00%",
      change: "-100.0%",
    },
    {
      id: 4,
      asset: "Other Liquid Tokens",
      amount: "-",
      value: "$0",
      purchaseValue: "$0",
      allocation: "0.00%",
      change: "-100.0%",
    },
    {
      id: 5,
      asset: "Other Liquid Tokens",
      amount: "-",
      value: "$0",
      purchaseValue: "$0",
      allocation: "0.00%",
      change: "-100.0%",
    },
    {
      id: 6,
      asset: "Other Liquid Tokens",
      amount: "-",
      value: "$0",
      purchaseValue: "$0",
      allocation: "0.00%",
      change: "-100.0%",
    },
    {
      id: 7,
      asset: "Other Liquid Tokens",
      amount: "-",
      value: "$0",
      purchaseValue: "$0",
      allocation: "0.00%",
      change: "-100.0%",
    },
  ]);
  const [datanft, setDatanft] = useState([
    {
      id: 1,
      asset: "USD Coin",
      amount: "35,958,811",
      value: "$35,958,811",
      purchaseValue: "	$35,347,172	",
      allocation: "30.44%",
      change: "	+2.4%",
    },
    {
      id: 2,
      asset: "Tether USD",
      amount: "3,186,072",
      value: "$3,186,072",
      purchaseValue: "	$3,186,072	",
      allocation: "2.70%	",
      change: "+148.0%",
    },
    {
      id: 3,
      asset: "Other Liquid Tokens",
      amount: "-",
      value: "$0",
      purchaseValue: "$0",
      allocation: "0.00%",
      change: "-100.0%",
    },
    {
      id: 4,
      asset: "Other Liquid Tokens",
      amount: "-",
      value: "$0",
      purchaseValue: "$0",
      allocation: "0.00%",
      change: "-100.0%",
    },
    {
      id: 5,
      asset: "Other Liquid Tokens",
      amount: "-",
      value: "$0",
      purchaseValue: "$0",
      allocation: "0.00%",
      change: "-100.0%",
    },
    {
      id: 6,
      asset: "Other Liquid Tokens",
      amount: "-",
      value: "$0",
      purchaseValue: "$0",
      allocation: "0.00%",
      change: "-100.0%",
    },
    {
      id: 7,
      asset: "Other Liquid Tokens",
      amount: "-",
      value: "$0",
      purchaseValue: "$0",
      allocation: "0.00%",
      change: "-100.0%",
    },
  ]);
  const columns = [
    {
      name: "Asset",

      selector: (row) => row.asset,
    },
    {
      name: "Amount",
      selector: (row) => row.amount,
    },
    {
      name: "Value",
      selector: (row) => row.value,
    },
    {
      name: "Purchase Value",
      selector: (row) => row.purchaseValue,
    },
    {
      name: "Allocation %",
      selector: (row) => row.allocation,
    },
    {
      name: "% Change Q on Q",

      selector: (row) => row.change,
    },
  ];

  return (
    <div className="container poetsen-one-regular">
      <div className="wallet-overview treasury-bg treasurywallet-tabs mt-5">
        <h4 style={{ paddingBottom: "0" }}>Treasury Wallets</h4>
        <p style={{ paddingBottom: "1rem" }}>
          Treasury funds are stored in various wallets across different chains.
        </p>
        <Tabs
          defaultActiveKey="base"
          transition={false}
          id="noanim-tab-example"
          className="mb-3"
        >
          <Tab eventKey="base" title="Base">
            <div className="row">
              <div className="col-lg-4  col-6 wallet-treasury-navs condobase-token-api">
                <NavLink to="/home/condobasetreasury">
                  <div className="ether-row-1">
                    <div className="treasury-data">
                      <h3>Condo base treasury</h3>
                    </div>
                    <div className="contract-add contract-add-newcss">
                      {`${condobasecontractAddress.slice(
                        0,
                        6
                      )}....${condobasecontractAddress.slice(-6)}`}
                    </div>
                    <div className="dots-tokenomics-overview"></div>
                    <div className="dots-tokenomics-2-overview"></div>
                    <div className="dots-tokenomics-3-overview"></div>
                    <div className="dots-tokenomics-4-overview"></div>{" "}
                  </div>
                </NavLink>
              </div>
              <div className="col-lg-4  col-6 wallet-treasury-navs">
                <NavLink to="/home/tresury3treasury">
                  <div className="ether-row-1 ">
                    <div className="treasury-data">
                      <h3>Treasury 3</h3>
                    </div>
                    <div className="contract-add contract-add-newcss">
                      {`${treasurycontractAddress.slice(
                        0,
                        6
                      )}....${treasurycontractAddress.slice(-6)}`}
                    </div>
                    <div className="dots-tokenomics-overview dots-tokenomics-rt1"></div>
                    <div className="dots-tokenomics-2-overview dots-tokenomics-rt2"></div>
                    <div className="dots-tokenomics-3-overview dots-tokenomics-rt3"></div>
                    <div className="dots-tokenomics-4-overview dots-tokenomics-rt4"></div>
                  </div>{" "}
                </NavLink>
              </div>
              {/* <div className="col-lg-4  col-6 wallet-treasury-navs dev-wallet-treasury">
                <NavLink to="/home/devwallet">
                  <div className="ether-row-1 ">
                    <div className="treasury-data">
                      <h3>Dev Wallet</h3>
                    </div>
                    <div className="contract-add contract-add-newcss">
                      {`${devWalletAddress.slice(
                        0,
                        6
                      )}....${devWalletAddress.slice(-6)}`}
                    </div>
                    <div className="dots-tokenomics-overview dots-tokenomics-rt1"></div>
                    <div className="dots-tokenomics-2-overview dots-tokenomics-rt2"></div>
                    <div className="dots-tokenomics-3-overview dots-tokenomics-rt3"></div>
                    <div className="dots-tokenomics-4-overview dots-tokenomics-rt4"></div>
                  </div>{" "}
                </NavLink>
              </div> */}
            </div>
          </Tab>
          <Tab eventKey="ethereum" title="Ethereum">
            <div className="row">
              <div className="col-lg-4 col-6 wallet-treasury-navs">
                {" "}
                <NavLink to="/home/condoethereumtreasury">
                  <div className="ether-row-1">
                    <div className="treasury-data">
                      <h3>Condo ethereum treasury</h3>
                    </div>
                    <div className="contract-add contract-add-newcss">
                      {`${condobaseEtherAddress.slice(
                        0,
                        6
                      )}....${condobaseEtherAddress.slice(-6)}`}
                    </div>{" "}
                    <div className="dots-tokenomics-overview"></div>
                    <div className="dots-tokenomics-2-overview"></div>
                    <div className="dots-tokenomics-3-overview"></div>
                    <div className="dots-tokenomics-4-overview"></div>{" "}
                  </div>
                </NavLink>
              </div>

              <div className="col-lg-4 col-6 wallet-treasury-navs">
                <NavLink to="/home/tresury3treasury">
                  <div className="ether-row-1">
                    <div className="treasury-data">
                      <h3>Treasury 3</h3>
                    </div>
                    <div className="contract-add contract-add-newcss">
                      {`${treasurycontractAddress.slice(
                        0,
                        6
                      )}....${treasurycontractAddress.slice(-6)}`}
                    </div>{" "}
                    <div className="dots-tokenomics-overview"></div>
                    <div className="dots-tokenomics-2-overview"></div>
                    <div className="dots-tokenomics-3-overview"></div>
                    <div className="dots-tokenomics-4-overview"></div>{" "}
                  </div>{" "}
                </NavLink>
                <div className="dots-tokenomics-overview"></div>
                <div className="dots-tokenomics-2-overview"></div>
                <div className="dots-tokenomics-3-overview"></div>
                <div className="dots-tokenomics-4-overview"></div>
              </div>

              <div className="col-lg-4 col-6 wallet-treasury-navs wallet-mapletreasury-navs">
                {" "}
                <NavLink to="/home/mapleCondoTreasury">
                  <div className="ether-row-1">
                    <div className="treasury-data">
                      <h3>Condo syrup treasury</h3>
                    </div>
                    <div className="contract-add contract-add-newcss">
                      {`${condobasecontractAddress.slice(
                        0,
                        6
                      )}....${condobasecontractAddress.slice(-6)}`}
                    </div>{" "}
                    <div className="dots-tokenomics-overview"></div>
                    <div className="dots-tokenomics-2-overview"></div>
                    <div className="dots-tokenomics-3-overview"></div>
                    <div className="dots-tokenomics-4-overview"></div>{" "}
                  </div>{" "}
                </NavLink>
                <div className="dots-tokenomics-overview"></div>
                <div className="dots-tokenomics-2-overview"></div>
                <div className="dots-tokenomics-3-overview"></div>
                <div className="dots-tokenomics-4-overview"></div>
              </div>
            </div>
          </Tab>
          <Tab eventKey="polygon" title="Polygon">
            <div className="row wallet-treasury-navs">
              <NavLink to="/home/polygoncondotreasury">
                <div className="col-lg-4 col-6">
                  <div className="ether-row-1">
                    <div className="treasury-data">
                      <h3>Condo polygon treasury</h3>
                    </div>
                    <div className="contract-add contract-add-newcss">
                      {`${condoPolygonTreasury.slice(
                        0,
                        6
                      )}....${condoPolygonTreasury.slice(-6)}`}
                    </div>{" "}
                    <div className="dots-tokenomics-overview"></div>
                    <div className="dots-tokenomics-2-overview"></div>
                    <div className="dots-tokenomics-3-overview"></div>
                    <div className="dots-tokenomics-4-overview"></div>{" "}
                  </div>
                </div>
                <div className="col-lg-4 col-6"></div>
                <div className="col-lg-4 col-6"></div>{" "}
              </NavLink>
            </div>
          </Tab>{" "}
          <Tab eventKey="bnb" title="BNB">
            <div className="row wallet-treasury-navs">
              <NavLink to="/home/bnbcondotreasury">
                <div className="col-lg-4 col-6">
                  <div className="ether-row-1">
                    <div className="treasury-data">
                      <h3>Condo BNB treasury</h3>
                    </div>
                    <div className="contract-add contract-add-newcss">
                      {`${condobasecontractAddress.slice(
                        0,
                        6
                      )}....${condobasecontractAddress.slice(-6)}`}
                    </div>{" "}
                    <div className="dots-tokenomics-overview"></div>
                    <div className="dots-tokenomics-2-overview"></div>
                    <div className="dots-tokenomics-3-overview"></div>
                    <div className="dots-tokenomics-4-overview"></div>{" "}
                  </div>
                </div>
                <div className="col-lg-4 col-6"></div>
                <div className="col-lg-4 col-6"></div>
              </NavLink>
            </div>
          </Tab>
        </Tabs>
      </div>
    </div>
  );
};

export default TreasureOverview;
